import { BusinessTargetConfig } from '@shopee-user/global';
import { config } from '@shopee-user/platform';
import { getOrCreateCsrfTokenCookie } from '@tob/shared/security/csrf';

const { BUSINESS_TARGET, ENV, LOCALE, DEV, IS_LOCAL } = config;

const { appType, getApiDomain } = BusinessTargetConfig[BUSINESS_TARGET];

export const ABSOLUTE_URL_REGEX = /^http(s)?:\/\//i;

// BE requires this custom header to differentiate between ToB app_type
export const CUSTOM_HEADERS = {
  'x-app-type': appType.toString(),
  'X-CSRFToken': getOrCreateCsrfTokenCookie({ cookiePrefix: '' }),
};

export const API_URL: string = DEV || IS_LOCAL ? '' : getApiDomain(ENV, LOCALE);
